import { Configuration, FrontendApi } from '@ory/client-fetch'

import { config } from '@/lib/helpers/config.helpers'

export type OryApi = {} & FrontendApi

export const ory = new FrontendApi(
  new Configuration({
    basePath: config.oryApiUrl,
    credentials: 'include',
  }),
)
